import i18n from '@/plugins/i18n';
import { SelectOption } from '@/types/types';

export function visibilityOptions(): SelectOption<boolean>[] {
  return [
    {
      label: i18n.t('attachments.visible').toString(),
      value: false
    },
    {
      label: i18n.t('attachments.private').toString(),
      value: true
    }
  ];
}
